<template>
    <tr class="c-tr">
        <td @click="editItem">
            {{ data.distribution_id }}
        </td>
        <td @click="editItem">{{ data.title }}</td>
        <td @click="editItem">{{ types.find(type => type.value === data.type.toString()).label }}</td>
        <td @click="editItem">{{ formatDate(data.created_on) }}</td>
        <td @click="editItem" class="text-right">${{ formatNumber(data.amount) }}</td>
        <td>
            <a href="javascript:;">
                <img
                    src="@/assets/images/copy.svg"
                    class="ml-2"
                    @click="
                        copyToClipboard(
                            data.distribution_url
                        )
                    "
                />
            </a>
        </td>
    </tr>
</template>

<script>
import DibbleJs from "@/dibble";
import Authorizations from "@/utils/authorizations";

export default {
    name: 'DesignationTableItem',
    props: {
        data: Object,
        types: Array
    },
    methods: {
        editItem() {
            if (DibbleJs.isAllowedAccess(Authorizations.MODULE_NAMES.CAMPAIGN_DISTRIBUTION_EDIT)) {
                this.$emit('editItem', this.data);
            }
        },
        formatDate(date) {
            return this.$moment(date).format('MM/DD/YYYY HH:mm');
        },
        formatNumber(number) {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        copyToClipboard(text) {
            const el = document.createElement('textarea');
            el.value = text;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            DibbleJs.toastSuccessMessage(
                'The link was copied to the clipboard'
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.c-tr {
    td {
        color: #7c7c7a;
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
        cursor: pointer;

        &:first-child {
            min-width: 200px;
        }
    }
}
</style>
